import React, { useState } from "react";
import { Input } from "./input";
import { Eye, EyeOff } from "lucide-react";

/** Champ mot de passe avec œil afficher/masquer. Mêmes props que Input. */
export const PasswordInput = React.forwardRef(({ className = "", ...props }, ref) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} type={show ? "text" : "password"} className={`pr-10 ${className}`} {...props} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
        aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        data-testid={(props["data-testid"] || "password") + "-eye"}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
